import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { CommonDataService } from './common-data.service';
import { httpExtensionService } from './httpextension.service';
@Injectable()
export class AccountService {

    constructor(private http: httpExtensionService, private config: ConfigService, private sessionService: SessionService, private commonDataService: CommonDataService) { }

    getMemberDetails() {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.getMemberDetails, {
            headers: headers
        })
    }

    addProductCard(data) {
        let body = this.commonDataService.urlDataDecoded(data);
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.addProductCard, body, {
            headers: headers
        })
    }

    updateMemberProfile(userData) {
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.put(this.config.apiURI + this.config.updateMemberProfile, body, {
            headers: headers
        })
    }

    addMemberAddress(userData) {
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.addMemberAddress, body, {
            headers: headers
        })
    }

    contactCompany(userData) {
        let body = this.commonDataService.urlDataDecoded(userData);
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(this.config.apiURI + this.config.contactCompany, body, {
            headers: headers
        })
    }

    getBeneficiaries(data) {
        let body = data;
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.post(this.config.getMemberBeneficiaries, body, {
            headers: headers
        })
    }

    private handleError(error: any) {
        return Observable.throw(error.json());
    }

    getProductByCardNum(cardNum) {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.getProductByCardNum + cardNum, {
            headers: headers
        })
    }

    getMemberStatistics() {
        let user_token: string = this.sessionService.getToken();
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + user_token);
        return this.http.get(this.config.apiURI + this.config.getMemberStatistics, {
            headers: headers
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/account.service.ts